import { ApplicationState } from 'store'
import { Invoice } from 'modules/invoice/models'

export const getInvoice = (state: ApplicationState): Invoice | null =>
  state.invoice.currentInvoice.code ? state.invoice.currentInvoice : null
